import './SankeyChart.css';
export var canvasAreaCell = '_s3m3d3-3-15-1';
export var canvasZone = '_s3m3d4-3-15-1';
export var graphAreaCell = '_s3m3d2-3-15-1';
export var graphAreaContainer = '_s3m3d1-3-15-1';
export var graphAreaWrapper = '_s3m3d0-3-15-1';